const Roles = {
  ROLE_CLIENT: '1',
  ROLE_AGENT: '2',
  ROLE_ADMIN: '3',
  ROLE_ACCOUNTING: '4',
  ROLE_OPERATIONS: '5',
  ROLE_MANAGER: '6'  
};

Roles.install = function (Vue) {
    Vue.prototype.$getConstRole = (key) => {
        return Roles[key];
    }
}

export default Roles;
